export const PLAT = 'plat'
